import type { ReactNode } from 'react';

interface VariableCardProps {
    name: string;
    value: ReactNode;
    footer?: ReactNode;
    headerRight?: ReactNode;
}

const VariableCard = ({ name, value, footer, headerRight }: VariableCardProps) => (
    <div className="panel panel-default margin-bottom-0">
        <div className="panel-body padding-10">
            <div className="display-flex justify-content-between align-items-center">
                <div className="font-family-mono text-size-12 text-bold text-color-primary">{name}</div>
                {headerRight}
                <div
                    className={[
                        'bg-lightest padding-5 rounded border border-color-light',
                        'font-family-mono text-size-14 text-bold flex-0-0-auto',
                    ].join(' ')}
                >
                    {value}
                </div>
            </div>
            {footer && <div className="margin-top-5">{footer}</div>}
        </div>
    </div>
);

export default VariableCard;
